import HeaderSlider from "../../components/common/HeaderSlider";
import {Container, Row, Col} from "react-bootstrap";
import {Segmented} from "antd";
import {BarsOutlined, AppstoreOutlined, AppstoreAddOutlined} from "@ant-design/icons";
import { useEffect, useState} from "react";
import ProductList from "./product/ProductList";
import { Link, useNavigate } from "react-router-dom";
import { logoutAsync, selectIsOwner } from "../../app/store/reducers/auth/authReducer";
import { useSelector, useDispatch } from 'react-redux';
import { SHAPE_KANBAN } from "../../enums/Enum";
import axios from 'axios';

const MainPage = () => {
  const [shape, setShape] = useState(SHAPE_KANBAN);
  const isOwner = useSelector(selectIsOwner)
  const navigate = useNavigate()
  const dispatch = useDispatch()


  useEffect(() => {
    const unauthorizedInterceptor = axios.interceptors.response.use(response => {
      console.log("res", response)
      return response
  }, error => {
      console.log("error", error)
      // if (error?.response?.status === 401) {
          // dispatch(logoutAsync())
      // } else 
      if (error?.response?.status === 403) {
        console.log("test")
        navigate("/errors/403")
      }

      return Promise.reject(error);
  })

  return() => {
    axios.interceptors.response.eject(unauthorizedInterceptor);
  }
  },[])


  
  return (
    <>
      <HeaderSlider />
      <Container>
        <Row className="my-5">
          <h1 className="text-center">Collection</h1>
          <Col className="d-flex align-items-center justify-content-between">
            <Segmented
              options={[
                {
                  value: "List",
                  icon: <BarsOutlined />,
                  disabled: true
                },
                {
                  value: "Kanban",
                  icon: <AppstoreOutlined />,
                  disabled: true
                },
              ]}
              value={shape}
              onChange={setShape}
            />
            
            {isOwner &&
              <Link to="/product/register">
                <AppstoreAddOutlined style={{fontSize: "25px", color: "blue", border: "2px blue solid", borderRadius: "50%", padding: "3px"}} />
              </Link>
            }
          </Col>
        </Row>

        <ProductList shape={shape} />
      </Container>
    </>
  );
};

export default MainPage;
